import React from "react";
import styles from "./commissioningPDF.module.css";
import { baseURL } from "../../../services/api.service";

const CommissioningPDF = ({ data, groupedItems }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const formatNumberWithBreaks = (num) => {
    if (!num && num !== 0) return "-";
    return parseFloat(num).toLocaleString("en-IN", {}).replace(/,/g, ",\u200B");
  };
  let serialNumber = 1;
  const FloatValue = (value) => {
    return parseFloat(value);
  };
  return (
    <div className={styles.mainContainer}>
      <div className={styles.header}>
        <div className={styles.logoSection}>
          <img
            src="https://bermadimsapi.disctesting.in/uploads/logo/8e08ec4e6348fc2fe1f64ae147db7496.jpeg"
            alt="BERMAD"
            className={styles.logo}
          />
          <div className={styles.companyName}>
            BERMAD INDIA Private Limited.
          </div>
        </div>
        <div className={styles.addressRight}>
          <h2 className={styles.orderTitle}>Commissioning Details</h2>
          <div>
            <strong>Project Name:</strong>
            {data?.commissioning_details?.[0]?.installation_obj?.installation
              ?.projectDetails?.project_name || "-"}
          </div>
          <div>
            <br />
            <strong>Project Code:</strong>
            {data?.commissioning_details?.[0]?.installation_obj?.installation
              ?.projectDetails?.project_code || "-"}
          </div>
        </div>
      </div>
      <div className={styles.blueBar}></div>

      <table className={styles.orderHeader}>
        <tbody>
          <tr>
            {/* <th style={{ width: "25%" }}>Commission Person Name:</th> */}
            <th style={{ width: "25%", textAlign: "left" }}>Date:</th>
            <th style={{ width: "25%", textAlign: "left" }}>
              Commissioning No
            </th>
            <th style={{ width: "25%", textAlign: "left" }}>
              Commissioning Status
            </th>
            <th style={{ width: "25%", textAlign: "left" }}>
              Commissioning Person
            </th>
          </tr>
          <tr>
            {/* <td style={{ width: "25%" }}>Vinayak Shinde</td> */}
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {formatDate(data?.createdAt) || "-"}
            </td>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {data?.commissioning_no || "-"}
            </td>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {(() => {
                const installation = data?.installation;

                if (installation?.is_commissioning_paid) {
                  return <span>Commissioning Paid</span>;
                } else if (installation?.is_commissioning_claimed) {
                  return <span>Commissioning Claimed</span>;
                } else if (installation?.status === "commissioning_completed") {
                  return <span>Commissioning Completed</span>;
                } else {
                  return <span>-</span>;
                }
              })()}
            </td>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {data.creator
                ? data.creator?.first_name + " " + data.creator?.last_name
                : "-"}
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <table className={styles.catalogTable}>
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Item Code</th>
              <th>UOM</th>
              <th>Date</th>
              <th>Installed Quantity</th>
              <th>Remark</th>
              <th>Is Check</th>
            </tr>
          </thead>
          <tbody>
            {Object.values(groupedItems).map((group, index) => (
              <React.Fragment key={group.makeItem.unique_id}>
                {group.makeItem.is_make_item && (
                  <tr>
                    <td className={styles.textCenter}>{serialNumber++}</td>
                    <td>
                      <div className={styles.itemDescription}>
                        <div className={styles.itemCode}>
                          {group.makeItem.item_code || "N/A"}
                        </div>
                        <div className={styles.itemDesc}>
                          <span>Product Description:</span>
                          <br />
                          {group?.makeItem?.make_item_desc || "N/A"}
                        </div>
                      </div>
                    </td>
                    <td className={styles.textCenter}>
                      {group?.makeItem?.make_item_uom}
                    </td>

                    <td className={styles.textCenter}>{"-"}</td>
                    <td className={styles.textRight}>{"-"}</td>
                    <td className={styles.textCenter}>{"-"}</td>
                    <td className={styles.textCenter}>{"-"}</td>
                  </tr>
                )}

                {group.buyItems
                  .filter((item) => item.is_make_item)
                  .map((row, subIndex) => (
                    <tr key={row.unique_id} className={styles.subItemRow}>
                      <td
                        className={`${styles.textCenter} ${styles.subItemIndex}`}
                      >
                        {`${serialNumber - 1}.${subIndex + 1}`}
                      </td>
                      <td>
                        <div className={styles.subItemCode}>
                          {row?.buy_item_code || "N/A"}
                          <div className={styles.subItemDesc}>
                            <span>Product Description:</span>
                            <br />
                            {row?.description || "N/A"}
                          </div>
                        </div>
                      </td>
                      <td className={styles.textCenter}>{row?.uom || "N/A"}</td>
                      <td className={styles.textCenter}>
                        {formatDate(row?.date) || "-"}
                      </td>
                      <td className={styles.textRight}>
                        <div className={styles.numberWrapper}>
                          {formatNumberWithBreaks(row?.installed_qty) || 0}
                        </div>
                      </td>
                      <td className={styles.textCenter}>
                        {row?.remark || "-"}
                      </td>
                      <td className={styles.textCenter}>
                        {row?.is_check || "-"}
                      </td>
                    </tr>
                  ))}
                {group.buyItems
                  .filter((item) => item.is_make_item == false)
                  .map((row, subIndex) => (
                    <tr key={row.unique_id}>
                      <td className={styles.textCenter}>{serialNumber++}</td>

                      <td>
                        <div className={styles.itemDescription}>
                          <div className={styles.itemCode}>
                            {row?.item_code || "N/A"}
                          </div>
                          <div className={styles.itemDesc}>
                            <span>Product Description:</span>
                            <br />
                            <span> {row?.description || "N/A"}</span>
                          </div>
                        </div>
                      </td>
                      <td className={styles.textCenter}> {row?.uom || "-"}</td>
                      <td className={styles.textCenter}>
                        {formatDate(row?.date) || "-"}
                      </td>

                      <td className={styles.textRight}>
                        <div className={styles.numberWrapper}>
                          {isNaN(row?.installed_qty)
                            ? 0
                            : formatNumberWithBreaks(row?.installed_qty) || "0"}
                        </div>
                      </td>
                      <td className={styles.textCenter}>
                        {row?.remark || "-"}
                      </td>
                      <td className={styles.textCenter}>
                        {row?.is_check || "-"}
                      </td>
                    </tr>
                  ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      {data?.file?.length > 0 && (
        <div className="p-3">
          <h6 className="h-6-pdfheading">Images:</h6>
          <div
            className="row mt-2"
            style={{ display: "flex", flexWrap: "wrap" }}
          >
            {data &&
              data?.file?.length > 0 &&
              data?.file.map((item, index) => (
                <img
                  src={baseURL + item.filePath}
                  alt="Installation Image"
                  style={{
                    width: "300px",
                    height: "300px",
                    borderRadius: "5px",
                    marginBottom: "10px",
                  }}
                />
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CommissioningPDF;